module.exports = __webpack_public_path__ + "static/todomvc.97b75bff.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/todomvc.png
// module id = 861
// module chunks = 73261030922168